import { render, staticRenderFns } from "./LmUploadImageBuilderUi.vue?vue&type=template&id=5d88d3a6&"
import script from "./LmUploadImageBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmUploadImageBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports